import React, {useState, useEffect} from 'react';
import {PropTypes} from 'prop-types';
import {parse} from 'query-string';
import {FormattedMessage} from 'react-intl';

import {FAN_PROTECT_LINKS} from '@stubhub/general-utils';
import FormattedLink from '@stubhub/react-formatted-link';
import {connect} from '@stubhub/react-store-provider';
import UserInfoMessage from '@stubhub/react-user-info-message';

import controller from './controller';

import './index.scss';

export const STORAGE_KEY = 'SH_SEM_BannerDisplayed';

const GoogleSemMessage = ({isFeatureOn = false, isHomepage = false, showDisclaimerEnabled = false}, context) => {
  const [displayBanner, setDisplayBanner] = useState(false);
  const {globalRegistry} = context;
  const locale = globalRegistry.getCurrentLocale()?.toLowerCase();
  const fan_protect_url = FAN_PROTECT_LINKS[locale] || FAN_PROTECT_LINKS.default;
  const validTriggers = () => {
    const {gclid, utm_medium: utmMedium, tduid, valueMessaging} = parse(window?.location?.search?.substring(1));

    return (
      gclid ||
      tduid ||
      ['cpc', 'affiliate', 'tradedoubler'].includes(utmMedium) ||
      valueMessaging === 'true' ||
      showDisclaimerEnabled
    );
  };

  const dependencyWatcher = __CLIENT__ ? [window.location.href] : undefined; // SSR doesn't even like the window? attempt
  useEffect(() => {
    const previousSession = window?.sessionStorage?.getItem(STORAGE_KEY);
    if (isFeatureOn && validTriggers() && (!previousSession || isHomepage)) {
      window?.sessionStorage?.setItem(STORAGE_KEY, true);
      setDisplayBanner(true);
    }

    return () => {
      setDisplayBanner(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyWatcher);

  return (
    displayBanner && (
      <UserInfoMessage>
        <span className="Google-SEM-Message" data-testid="Google-SEM-Message">
          <FormattedMessage
            id="Header.google.sem.message"
            defaultMessage="The marketplace for live event tickets since 2009. {link} Prices may vary from face value."
            values={{
              link: (
                <FormattedLink className="Google-SEM-Message__link" href={fan_protect_url} externalLink>
                  <FormattedMessage
                    id="Header.google.sem.message.link"
                    defaultMessage="Every order is 100% guaranteed."
                  />
                </FormattedLink>
              ),
            }}
          />
        </span>
      </UserInfoMessage>
    )
  );
};

GoogleSemMessage.propTypes = {
  /** This is the feature toggle value for this particular usage */
  isFeatureOn: PropTypes.bool,

  /** Lets the component know if the current location is the homepage */
  isHomepage: PropTypes.bool,

  /** If FF common.googleResellerDisclaimer.show is enabled */
  showDisclaimerEnabled: PropTypes.bool,
};

export default connect(controller)(GoogleSemMessage);
